import Accordion from "../element/accordion";
import Footer from "../layout/footer";
import Header from "../layout/header-3";
import Link from 'next/link';
import { NextSeo, BreadcrumbJsonLd } from 'next-seo';

function FAQ() {
  return (
    <>
	<NextSeo
		title="اسئلة شائعة | eSmart"
		canonical="https://esmart.sa/faq"
	/>
	<BreadcrumbJsonLd
		itemListElements={[
			{
			position: 1,
			name: 'الرئيسية',
			item: 'https://esmart.sa',
			},
			{
			position: 2,
			name: 'اسئلة شائعة',
			item: 'https://esmart.sa/faq',
			},
		]}
		/>
	<Header/>
      <div className="page-content bg-white">
		{/* <!-- Banner  --> */}
		<div className="dlab-bnr-inr overlay-primary-dark" style={{"backgroundImage":"url(images/banner/bnr1.jpg)"}}>
			<div className="container">
				<div className="dlab-bnr-inr-entry">
					<h1>اسئلة شائعة</h1>
					{/* <!-- Breadcrumb Row --> */}
					<nav aria-label="breadcrumb" className="breadcrumb-row">
						<ul className="breadcrumb">
							<li className="breadcrumb-item"><Link legacyBehavior href="/"><a>الرئيسية</a></Link></li>
							<li className="breadcrumb-item active" aria-current="page">اسئلة شائعة</li>
						</ul>
					</nav>
					{/* <!-- Breadcrumb Row End --> */}
				</div>
			</div>
		</div>
		{/* <!-- Banner End --> */}
		
		{/* <!-- Faq --> */}
		<section className="content-inner" style={{"backgroundImage":"url(images/background/bg1.png)"}}>
			<div className="container">
				<div className="row">
					<div className="col-lg-8 m-auto wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
						<Accordion/>
					</div>
				</div>
			</div>
		</section>
	</div>
	<Footer/>
    </>
  )
}

export default FAQ;